import React, {  Fragment } from "react";
import Grid from "@material-ui/core/Grid";
import {  Container } from "@material-ui/core";
import { useHeader } from "../../bill-template02/style";
import { getcolor } from "../../invCompany/A4/UnderHeader";
import { styleFooterNotesAr } from "../../ShareFunctionsPrint";

function Footer(props) {
    const { InvForFatora, found, sta, locInv } = props;

    const classHeader = useHeader();
    const invColors = sta?.StngIA?.colors;
    const secondColor = getcolor(invColors);

    const sty = {
        cntr: { textAlign: "center", padding: 10, fontFamily: "Amiri-Regular" },
        lft: { textAlign: "left", padingLeft: 5 },
        rit: { textAlign: "right", padingRight: 5 },
        dirR: { direction: "rtl", color: "black" },
        dirL: { direction: "ltr", padding: 10 },
    };
    return (
        <Fragment>
            <Container style={{ direction: "rtl", fontFamily: "Amiri-Regular" }}>
                <Grid item container style={sty.cntr}>
                    <Grid item container>
                        <Grid item xs={12}>
                            {InvForFatora.notes}
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
            {locInv?.largeNum !== 28 &&
                locInv?.ProcTypeInvProc != "04" &&
                (
                    <Grid
                        item
                        container
                        style={{
                            fontWeight: "bold",
                            border: "solid 0.1px",
                            borderColor: secondColor,
                            direction: "ltr",
                            fontFamily: "Amiri-Regular",
                            // maxHeight: "2cm",
                            padding:"5px"
                        }}
                    >
                        <Grid item xs={5} style={{ textAlign: "left" }}>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc1_footer_en}</div>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc2_footer_en}</div>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc3_footer_en}</div>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc4_footer_en}</div>
                        </Grid>

                        <Grid item xs={2}></Grid>

                        <Grid
                            item
                            xs={5}
                            className={classHeader.rightHeader}
                            style={{ textAlign: "right" }}
                        >
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}> {found.Disc1_footer_ar}</div>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc2_footer_ar}</div>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc3_footer_ar}</div>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc4_footer_ar}</div>
                        </Grid>
                    </Grid>
                )}
            {locInv?.largeNum === 28 && (
                <Grid item container xs={12} style={styleFooterNotesAr}>
                    {found.BillNotes}
                </Grid>
            )}

        </Fragment>
    );
}
export default Footer;
